var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewportContainer"},[_c('div',{ref:"vp",staticClass:"viewport"}),_c('div',{staticClass:"controls"},[_c('a',{on:{"click":function($event){return _vm.resetCamera()}}},[_vm._v("Reset Camera")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }